import { render, staticRenderFns } from "./DescontoQuantidade.vue?vue&type=template&id=16b986c9&scoped=true"
import script from "./DescontoQuantidade.vue?vue&type=script&lang=js"
export * from "./DescontoQuantidade.vue?vue&type=script&lang=js"
import style0 from "./DescontoQuantidade.vue?vue&type=style&index=0&id=16b986c9&prod&lang=css"
import style1 from "./DescontoQuantidade.vue?vue&type=style&index=1&id=16b986c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b986c9",
  null
  
)

export default component.exports